// @flow
import api from 'tim-api';
import { protocol as protocolEndPoint, exportProtocol, confidenceLoginSigtim } from 'endPoints';

export const state = {
  tokenConfidenceSigtim: [],
  trackingList: [],
  pagination: null
};

export const getters = {
  tokenConfidenceSigtim: (state: Object) => state.tokenConfidenceSigtim,
  trackingList: (state: Object) => state.trackingList,
  pagination: (state: Object) => state.pagination
};

export const mutations = {
  SET_TOKEN_CONFIDENCE_SIGTIM(state: Object, tokenConfidenceSigtim: Array<Object>) {
    state.tokenConfidenceSigtim = tokenConfidenceSigtim;
  },
  SET_TRACKING_LIST(state: Object, trackingList: Array<Object>) {
    state.trackingList = trackingList;
  },
  SET_PAGINATION(state: Object, pagination: Object) {
    state.pagination = pagination;
  }
};

export const actions = {
  fetchConfidenceSigtimLogin({ commit }: Action) {
    return api.post(confidenceLoginSigtim).then(({data}) => {
      commit('SET_TOKEN_CONFIDENCE_SIGTIM', data);
    }).catch(() => {
      commit('SET_TOKEN_CONFIDENCE_SIGTIM', []);
    });
  },
  setTrackingDefault({ commit }: Action) {
    commit('SET_TRACKING_LIST', []);
  },
  fetchTrackingByProtocol({ commit }: Action, protocol: string) {
    const url = `${protocolEndPoint}/${protocol}`;
    return api.get(url, {
      headers: { 'TokenSigtim': state.tokenConfidenceSigtim.token }
    }).then(({ data }) => {
      commit('SET_TRACKING_LIST', [{...data}]);
      commit('SET_PAGINATION', {
        current_page: data.current_page,
        first_page_url: data.first_page_url,
        from: data.from,
        last_page: data.last_page,
        last_page_url: data.last_page_url,
        next_page_url: data.next_page_url,
        path: data.path,
        per_page: data.per_page,
        prev_page_url: data.prev_page_url,
        total: data.total
      });
    });
  },
  fetchExportProtocol({ commit }: Action, { ids }: Object) {
    const url = `${exportProtocol}`;
    return api.post(url, { id: [...ids] }, { responseType: 'blob' });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
